import { frontendURL } from '../../../helper/URLHelper';
import PipelineBoardIndex from './pages/PipelineBoardIndex.vue';

// Sante-CRM: quadro Kanban do funil odontológico
export const routes = [
  {
    path: frontendURL('accounts/:accountId/pipeline'),
    name: 'pipeline_board_index',
    component: PipelineBoardIndex,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
